interface IProps {
    size?: string;
}

export const IconPoint = (props: IProps) => {
    const { size } = props;

    return (
        <svg width={size || "20"} height={size || "21"} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10.5" r="9.5" fill="url(#paint0_radial_6282_65837)" stroke="url(#paint1_linear_6282_65837)" />
            <path d="M6.875 16.125V5.5H11.0669C11.8728 5.5 12.5593 5.65391 13.1265 5.96173C13.6937 6.26609 14.1261 6.68978 14.4235 7.23279C14.7244 7.77234 14.8749 8.3949 14.8749 9.10046C14.8749 9.80603 14.7227 10.4286 14.4183 10.9681C14.114 11.5077 13.673 11.9279 13.0954 12.2288C12.5213 12.5297 11.8261 12.6802 11.0098 12.6802H8.33801V10.8799H10.6467C11.079 10.8799 11.4352 10.8056 11.7154 10.6569C11.999 10.5047 12.21 10.2954 12.3483 10.0291C12.4901 9.75934 12.561 9.44979 12.561 9.10046C12.561 8.74768 12.4901 8.43986 12.3483 8.177C12.21 7.91069 11.999 7.70489 11.7154 7.55963C11.4318 7.41091 11.0721 7.33655 10.6363 7.33655H9.1214V16.125H6.875Z" fill="url(#paint2_linear_6282_65837)" />
            <defs>
                <radialGradient id="paint0_radial_6282_65837" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9.91304 9.45652) rotate(89.5489) scale(11.0438 12.2382)">
                    <stop stop-color="#F2CA3C" />
                    <stop offset="1" stop-color="#F2AA3C" />
                </radialGradient>
                <linearGradient id="paint1_linear_6282_65837" x1="15.3043" y1="20.0652" x2="2.78261" y2="3.80435" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#C89137" />
                    <stop offset="1" stop-color="#FFF500" stop-opacity="0.2" />
                </linearGradient>
                <linearGradient id="paint2_linear_6282_65837" x1="10.8749" y1="5.5" x2="10.8749" y2="16.125" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FEF7E6" />
                    <stop offset="1" stop-color="#FFFFFD" />
                </linearGradient>
            </defs>
        </svg>


    );
};
